/**
 * @description - _preview-modal.js: Handling the preview modals
 *
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 */

const docBody = document.querySelector('body');

/**
 * @description - close the modal
 */
function closeModal() {
    docBody.classList.remove('active--modal');
    setTimeout(() => {
        if (document.querySelector('.js-modal__preview')) {
            document.querySelector('.js-modal__preview').remove();
        }
    }, 500);
}

/**
 * @description - Create the overlay element
 */
function createOverlay() {
    const overlay = document.createElement('div');
    overlay.className = 'c-overlay js-overlay';
    overlay.addEventListener('click', closeModal);
    docBody.appendChild(overlay);
}

/**
 * @description - Create the preview modal
 * @param {string} imgUrl
 */
function createPreviewModal(imgUrl) {
    const overlay = document.querySelector('.js-overlay');

    if (!overlay) createOverlay();

    const modal = document.createElement('div');
    modal.className = 'c-modal-img c-modal-img--preview js-modal__preview';
    modal.style.top = window.pageYOffset + 50 + 'px';

    let modalWidth = '';
    const checkImg = new Image();

    checkImg.onload = function() {
        modalWidth = checkImg.width + 'px';
        modal.style.width = modalWidth;
        document.body.appendChild(modal);
    };

    checkImg.src = imgUrl;

    const modalImg = document.createElement('img');
    modalImg.setAttribute('src', imgUrl);
    modal.appendChild(modalImg);

    const btnModalClose = document.createElement('button');
    btnModalClose.classList.add('c-modal-img__btn-close');
    btnModalClose.innerHTML = '<i class="fal fa-times"></i>';
    btnModalClose.addEventListener('click', function() {
        closeModal();
    });

    modal.appendChild(btnModalClose);

    docBody.classList.add('active--modal');
}

/**
 * @description - Add the event listeners
 */
const btnModalClose = document.querySelectorAll('.js-modal__close');
const previewButtons = document.querySelectorAll('.js-preview__btn-modal');
const overlay = document.querySelector('.js-overlay');

if (btnModalClose) {
    btnModalClose.forEach((btn) => {
        btn.addEventListener(('click'), closeModal);
    });
}

previewButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
        const imgUrl = btn.parentElement.querySelector('img').dataset.originalImg;
        createPreviewModal(imgUrl);
    });
});

if (overlay) {
    overlay.addEventListener('click', closeModal);
}
